import { ResourceLinkPicker } from './ResourceLinkPicker'
import { ResourceLinkRoot } from './ResourceLinkRoot'
import { ResourceLinkTrigger } from './ResourceLinkTrigger'

export const ResourceLink = {
  Root: ResourceLinkRoot,
  Trigger: ResourceLinkTrigger,
  Picker: ResourceLinkPicker,
}
